export const formatMoney = (valueInitial: string) => {
  const valueCleaned = valueInitial
    .replace('.', '')
    .replace(',', '')
    .replace(/\D/g, '');

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(
    parseFloat(valueCleaned) / 100
  );

  return `R$ ${result}`;
};
